import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutPerfAlertDefList extends Layout {
    layoutHeader: LayoutHeader;
    sourceperf_alert_def: DataSource;
    tableperf_alert_defList45: Table;
}
